<button appTooltip="Graticule Tool" class="esk-tool" [ngClass]="{'esk-tool--active' : active===true}" (click)="toggleGraticle()"><i class="fa fa-th"></i></button>
